import { render, staticRenderFns } from "./AccountConfigChat.vue?vue&type=template&id=14daec41&scoped=true"
import script from "./AccountConfigChat.vue?vue&type=script&lang=js"
export * from "./AccountConfigChat.vue?vue&type=script&lang=js"
import style0 from "./AccountConfigChat.vue?vue&type=style&index=0&id=14daec41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14daec41",
  null
  
)

export default component.exports